module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0016.jpg?v=b5869e07";